module.exports = __webpack_public_path__ + "img/head.7029bff8.png";